import { render, staticRenderFns } from "./OctTabs.vue?vue&type=template&id=0baf0545&scoped=true&"
import script from "./OctTabs.vue?vue&type=script&lang=js&"
export * from "./OctTabs.vue?vue&type=script&lang=js&"
import style0 from "./OctTabs.vue?vue&type=style&index=0&id=0baf0545&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf0545",
  null
  
)

export default component.exports